import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { withRetry } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await withRetry(() => api.get("/auth/me"), 3, 3000);
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      // CRITIQUE : retour OAuth — AuthCallback échange le session_id d'abord
      if (window.location.hash?.includes("session_id=")) {
        setLoading(false);
        return;
      }
      await refreshUser();
      setLoading(false);
    })();
  }, [refreshUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("studykit_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password, level, accountType = "eleve") => {
    const { data } = await api.post("/auth/register", { name, email, password, level, account_type: accountType });
    if (data.token) localStorage.setItem("studykit_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("studykit_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
